import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SafeHtmlPipe } from '../../../core/pipe/safe-html.pipe';
import { SwUpdateService } from '../../../core/services/sw.update.service';
import { ImportantMessageService } from './important-message.service';

@Component({
  selector:        'app-important-message',
  imports: [
    SafeHtmlPipe
  ],
  templateUrl:     './important-message.component.html',
  styleUrl:        './important-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportantMessageComponent implements OnInit {

  importantMessageService = inject(ImportantMessageService);
  swUpdateService = inject(SwUpdateService);
  destroyRef = inject(DestroyRef);
  public message = signal<string>(null);
  public showUpdate = signal(false);

  ngOnInit() {
    this.importantMessageService.message.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(v => {
        this.message.set(v);
      });
    this.swUpdateService
      .monitorServiceWorkerUpdate()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(val => {
        if (val.type === 'VERSION_READY') {
          this.showUpdate.set(true);
        }
      });
  }

  dismissMessage() {
    this.importantMessageService.message.next(null);
  }

  public reload() {
    this.showUpdate.set(false);
    window.location.reload();
  }
}
